<template>
  <div>
    <v-dialog v-model="internalDialog" max-width="600px" scrollable>
      <v-overlay :value="overlayComponent">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card style="height: auto;">
        <v-card-title class="justify-space-between">
        </v-card-title>
        <v-card-text class="px-5">
          <v-row>
            <v-col cols="6" class="text-left pt-10">
              <h3><strong>เปลี่ยนเวลานัดหมาย</strong></h3>
            </v-col>
          </v-row>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="formChangTime.remark"
                  outlined
                  label="หมายเหตุเพิ่มเติม"
                  auto-grow
                  :rules="[rules.required]"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="pt-0">
                <v-autocomplete
                  v-model="formChangTime.empSelect"
                  :items="employeeAdminName"
                  label="พนักงานที่รับนัดหมาย"
                  outlined
                  dense
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12">
                <v-select
                  v-model="formChangTime.masBranchID"
                  :label="languageSelect === 0 ? 'สาขา *' : 'Branch *'"
                  dense
                  outlined
                  :item-text="languageSelect === 0 ? 'text' : 'textEn'"
                  :items="branch"
                  attach
                  :menu-props="{ bottom: true, offsetY: true, maxHeight: '300px' }"
                  @change="selectBranch(), formChangTime.group_Flow_Id = ''"
                ></v-select>
                <v-select
                  v-if="formChangTime.masBranchID !== '' && formChangTime.masBranchID !== null"
                  v-model="formChangTime.group_Flow_Id"
                  :label="languageSelect === 0 ? 'ประเภทบริการ *' : 'Service *'"
                  dense
                  outlined
                  :item-text="languageSelect === 0 ? 'text' : 'textEn'"
                  :items="groupFlow"
                  attach
                  :menu-props="{ bottom: true, offsetY: true, maxHeight: '300px' }"
                  @change="selectGroupFlow(), formChangTime.flowId = ''"
                ></v-select>
                <v-select
                  v-if="formChangTime.group_Flow_Id !== '' && formChangTime.group_Flow_Id !== null"
                  v-model="formChangTime.flowId"
                  :label="languageSelect === 0 ? 'แพ็คเกจ *' : 'Packages *'"
                  :item-text="languageSelect === 0 ? 'text' : 'textEn'"
                  dense
                  outlined
                  :items="DataFlow"
                  attach
                  :menu-props="{ bottom: true, offsetY: true, maxHeight: '300px' }"
                  @change="checkBranch(), checkTitleEmp()"
                >
            </v-select>
              <div class="mb-5" v-if="formChangTime.masBranchID !== '' && formChangTime.group_Flow_Id !== '' && formChangTime.flowId !== ''">
                <v-item-group
                  v-model="selectedEmpList"
                  multiple
                >
                  <v-row>
                    <v-col
                      v-for="(emp,i) in dataEmpAll"
                      :key="i"
                      cols="6"
                      sm="6"
                      md="6"
                    >
                      <v-item :value="emp.empId" v-slot="{ active, toggle }">
                        <v-sheet
                          elevation="6"
                          class="pa-2"
                        >
                        <v-img
                          v-if="emp.empImge"
                          max-height="150"
                          max-width="250"
                          :src="emp.empImge"
                          @click="openDialogPreView(emp.picture[0].gallery)"
                        ></v-img>
                        <div
                          v-else
                          style="max-width: 250px; max-height: 150px; width: 100%; height: 100%; display: flex; justify-content: center; align-items: center; border: 1px dashed #ccc;"
                        >
                          <v-icon
                            style="font-size: 96px;"
                          >
                          mdi-image-multiple
                          </v-icon>
                        </div>
                          <div class="mt-2 d-flex align-center justify-space-between" @click="toggle">
                            <div>
                              <div class="font-weight-bold">
                                {{ languageSelect === 0 ? emp.empFull_NameTH : emp.empFull_NameEn }}
                              </div>
                              <div class="text--secondary">
                                {{ emp.empPosition }}
                              </div>
                            </div>
                            <v-icon color="primary">
                              {{ active ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                            </v-icon>
                          </div>
                        </v-sheet>
                      </v-item>
                    </v-col>
                  </v-row>
                </v-item-group>
              </div>
              </v-col>
            </v-row>
            <div v-if="formChangTime.masBranchID !== '' && formChangTime.group_Flow_Id !== '' && formChangTime.flowId !== ''">
              <div class="pa-0" v-if="!overlayBulidQueue">
                <div class="pa-0 mb-2 mt-n10">
                <v-row>
                  <v-col cols="2" class="text-center">
                    <v-icon
                      class="mr-n13"
                      v-if="previous"
                      large
                      color="#000000"
                      @click="setMonthCarousel('previous')"
                    >
                      mdi-skip-previous
                    </v-icon>
                  </v-col>
                  <v-col cols="8" class="text-center">
                  <v-menu
                    ref="menupicker"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="-80"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                        <h4
                        class="pa-1 text-center mt-0 font-weight-bold"
                        :style="'color:'+ '#000000' +';'"
                        v-bind="attrs"
                        v-on="on">
                        {{languageSelect === 0 ? defaultMonth.filter((v , k) => (k + 1) === parseInt(momenDate_MM(date)))[0] + ' ' + ' ' + (parseInt(momenDate_YYYY(date)) + 543) : defaultMonthEng.filter((v , k) => (k + 1) === parseInt(momenDate_MM(date)))[0] + ' ' + ' ' + (parseInt(momenDate_YYYY(date))) }}
                        </h4>
                    </template>
                    <v-date-picker
                      v-model="date"
                      type="month"
                      no-title
                      scrollable
                      @input="menu2 = false"
                      :min="currentMonth"
                      :locale="languageSelect === 0 ? 'th': 'sv-se'"
                      @change="setMonthCarousel()"
                    ></v-date-picker>
                  </v-menu>
                  </v-col>
                  <v-col cols="2" class="text-center">
                    <v-icon
                      class="ml-n13"
                      large
                      color="#000000"
                      @click="setMonthCarousel('next')"
                    >
                      mdi-skip-next
                    </v-icon>
                  </v-col>
                </v-row>
              </div>
          <v-slide-group
            v-model="model"
            center-active
            show-arrows
            class="pa-2 pt-0 mt-n1"
            color="primary"
          >
            <v-slide-item
              v-for="(item, n) in queueForMonth"
              :key="n"
            >
              <v-card
                v-if="!item.status_close"
                :color="item.active ? '#1F6FEB' : '#0D47A1'"
                :style="'border-radius: 15px 15px 15px 15px;'"
                class="ma-1 cardBox"
                height="65px"
                width="50px"
                v-on:click="item.active? item.active = false: item.active = true  ,getDetailsVela(item,n),dueTimeSelect = ''"
              >
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center"
                >
                <v-col cols="12" class="pa-0 " v-if="languageSelect === 0">
                  <p class="text-center pa-0 ma-0 mt-5 font-weight-bold" :style="'color:#FFFFFF'" >{{item.day_th + '.'}}</p>
                </v-col>
                <v-col cols="12" class="pa-0 " v-else>
                  <p class="text-center pa-0 ma-0 mt-5 font-weight-bold" :style="'color:#FFFFFF'" >{{item.day_en + '.'}}</p>
                </v-col>
                <v-col cols="12" class="pa-0" >
                  <h4 class="text-center pa-0 ma-0 mt-n1 font-weight-bold" :style="'color:#FFFFFF'" >{{item.day}}</h4>
                </v-col>
                </v-row>
              </v-card>
              <v-sheet
                v-else
                :color="item.active ? '#FFFFFF' : '#FFFFFF'"
                :style="'border-radius: 15px 15px 15px 15px;'"
                class="ma-1 cardBox"
                height="65px"
                width="50px"
                readonly
              >
                <v-row
                  class="fill-height"
                  align="center"
                  justify="center"
                >
                <v-col cols="12" class="pa-0 " v-if="languageSelect === 0">
                  <p class="text-center pa-0 ma-0 mt-5 font-weight-bold" :style="'color:#000000'" >{{item.day_th + '.'}}</p>
                </v-col>
                <v-col cols="12" class="pa-0 " v-else>
                  <p class="text-center pa-0 ma-0 mt-5 font-weight-bold" :style="'color:#000000'" >{{item.day_en + '.'}}</p>
                </v-col>
                <v-col  cols="12" class="pa-0" >
                  <h4 class="text-center pa-0 ma-0 mt-n1 font-weight-bold"  :style="'color:'+ '#000000'" >{{item.day}}</h4>
                </v-col>
                </v-row>
              </v-sheet>
            </v-slide-item>
          </v-slide-group>
          <v-expand-transition>
            <v-sheet
              v-if="queueForDateSelect.length > 0"
              min-height="200"
              tile
              class="pa-3 px-5 ml-2 mr-2"
            >
            <v-row>
              <v-col cols="4" class="pa-0">
                <h5 class="mt-3 font-weight-bold text-center" >
                  {{languageSelect === 0 ? 'เวลา': 'Time'}}
                </h5>
                <div v-for="(item , index) in queueForDateSelect" :key="index">
                  <h5  class="mt-3 font-weight-bold text-center" >
                    <div>
                      <v-sheet
                        class="font-weight-bold text-center"
                        color="#0D47A1"
                        width="100%"
                        height="36px"
                        elevation="2"
                        rounded
                        style="display: flex;justify-content: center;align-items: center;"
                        >
                      <p class="ma-0" style="word-wrap: break-word;color: #FFFFFF;font-size:small;">{{item}}</p>
                      </v-sheet>
                    </div>
                  </h5>
                </div>
              </v-col>
              <v-col cols="4" class="pa-0">
                <h5 class="mt-3 font-weight-bold text-center" >
                  {{languageSelect === 0 ? 'จำนวนคิว': 'Queues'}}
                </h5>
                <div v-for="(item , index) in queueForDateSelect" :key="index">
                  <h5  class="mt-3 font-weight-bold text-center" >
                    <div >
                      <v-btn
                        dark
                        class="font-weight-bold  text-center"
                        color="#0ACF83"
                        width="80%"
                        >{{languageSelect === 0 ? 'ว่าง': 'Ready'}}
                      </v-btn>
                    </div>
                  </h5>
                </div>
              </v-col>
              <v-col cols="4" class="pa-0">
                <h5 class="mt-3 font-weight-bold text-center" >
                  {{languageSelect === 0 ? 'จองคิว': 'Booking'}}
                </h5>
                <div v-for="(item , index) in queueForDateSelect" :key="index">
                  <h5  class="mt-3 font-weight-bold text-center" >
                    <div>
                      <v-btn
                        v-if="item === dueTimeSelect"
                        dark
                        class="font-weight-bold  text-center"
                        color="rgb(31, 111, 235)"
                        width="100%"
                        @click="selectTime(item)"
                        >
                        <v-icon left class="ml-1">
                          mdi-check-circle
                        </v-icon>
                        {{languageSelect === 0 ? 'ยกเลิก': 'Click'}}
                      </v-btn>
                      <v-btn
                      v-else
                        dark
                        class="font-weight-bold  text-center"
                        color="#0D47A1"
                        width="100%"
                        @click="selectTime(item)"
                        >
                        <v-icon left class="ml-1">
                          mdi-calendar-month
                        </v-icon>
                        {{languageSelect === 0 ? 'เลือก': 'Click'}}
                      </v-btn>
                    </div>
                  </h5>
                </div>
              </v-col>
            </v-row>
            </v-sheet>
          </v-expand-transition>
        </div>
        <div class="pa-0" v-else>
          <v-progress-linear
          indeterminate
          color="cyan"
          ></v-progress-linear>
        </div>
        </div>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="error"
            elevation="2"
            @click="internalDialog = false"
          >ยกเลิก</v-btn>
          <v-btn
            :disabled="(formChangTime.dueTime === dueTimeSelect && dueDateSelect === formChangTime.dueDate) || overlayComponent"
            color="primary"
            elevation="2"
            @click="ChangTimeCheck"
          >ยืนยัน</v-btn>
        </v-card-actions>
        <DialogPreView
      v-model="showDialogPreView"
      :gallery="prodGallery"
    />
      </v-card>
  </v-dialog>
  </div>
</template>

<script>
import axios from 'axios' // api
import moment from 'moment'
import DialogPreView from './DialogPreView.vue'
export default {
  name: 'DialogChangTime',
  components: {
    DialogPreView
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    dataChangTime: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showDialogPreView: false,
      prodGallery: [],
      valid: true,
      currentDate: moment().format('YYYY-MM-DD'),
      currentMonth: moment().format('YYYY-MM'),
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      internalDialog: this.value,
      menuDateChange: false,
      formChangTime: {
        remark: '',
        empSelect: '',
        dueDate: '',
        dueTime: '',
        group_Flow_Id: '',
        flowId: '',
        empId: '',
        masBranchID: '',
        datemonth: ''
      },
      employeeAdminName: [],
      groupFlow: [],
      dataFlow: [],
      DataFlowAll: [],
      DataFlow: [],
      branchData: [],
      branch: [],
      dataEmpAll: [],
      dataEmp: [],
      languageSelect: 0,
      empTitleTh: '',
      empTitleEng: '',
      selectedEmpList: [],
      queueForMonth: [],
      queueForDateSelect: [],
      overlayBulidQueue: false,
      previous: false,
      date: moment(moment().format('YYYY-MM'), 'YYYY-MM').format('YYYY-MM'),
      next_bookingNowCheckCount_month: 'False',
      dateEng: [{text: 'อา', textEn: 'Sun'}, {text: 'จ', textEn: 'Mon'}, {text: 'อ', textEn: 'Tue'}, {text: 'พ', textEn: 'Wed'}, {text: 'พฤ', textEn: 'Thu'}, {text: 'ศ', textEn: 'Fri'}, {text: 'ส', textEn: 'Sat'}],
      defaultMonth: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
      defaultMonthEng: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
      menu2: false,
      model: 0,
      timeSlow: null,
      dueDateSelect: '',
      dueTimeSelect: '',
      overlayComponent: false,
      statusStart: false
    }
  },
  watch: {
    async selectedEmpList (newVal, oldVal) {
      const isDifferent = JSON.stringify(newVal) !== JSON.stringify(oldVal)
      const hasValue = Array.isArray(newVal) && newVal.length > 0
      if (newVal.length === 0) {
        this.queueForMonth = []
        this.queueForDateSelect = []
      }
      if (isDifferent && hasValue) {
        const empListLimit = this.DataFlowAll.filter((item) => item.flowId === this.formChangTime.flowId)[0].empList
        if (newVal.length <= empListLimit) {
          await this.getCalendarQueueVela()
        } else {
          this.selectedEmpList = [...oldVal]
          this.$swal(this.languageSelect === 0 ? `เพิ่มสูงสุดได้ไม่เกิน ${empListLimit} ฉาก` : `You can add up to a maximum of ${empListLimit} scene.`, ' ', 'info')
        }
      }
    },
    value (val) {
      this.internalDialog = val
      if (val) {
        this.clearData()
        this.getEmpAdmin(this.dataChangTime)
        this.buildDataChangTime()
      }
    },
    internalDialog (val) {
      this.$emit('input', val) // sync กับ parent
    }
  },
  methods: {
    async clearData () {
      this.prodGallery = []
      this.valid = true
      this.currentDate = moment().format('YYYY-MM-DD')
      this.currentMonth = moment().format('YYYY-MM')
      this.menuDateChange = false
      this.formChangTime = {
        remark: '',
        empSelect: '',
        dueDate: '',
        dueTime: '',
        group_Flow_Id: '',
        flowId: '',
        empId: '',
        masBranchID: '',
        datemonth: ''
      }
      this.employeeAdminName = []
      this.groupFlow = []
      this.dataFlow = []
      this.DataFlowAll = []
      this.DataFlow = []
      this.branchData = []
      this.branch = []
      this.dataEmpAll = []
      this.dataEmp = []
      this.empTitleTh = ''
      this.empTitleEng = ''
      this.selectedEmpList = []
      this.queueForMonth = []
      this.queueForDateSelect = []
      this.overlayBulidQueue = false
      this.date = moment(moment().format('YYYY-MM'), 'YYYY-MM').format('YYYY-MM')
      this.menu2 = false
      this.model = 0
      this.timeSlow = null
      this.dueDateSelect = ''
      this.dueTimeSelect = ''
      this.overlayComponent = false
      this.statusStart = false
    },
    async openDialogPreView (gallery) {
      this.prodGallery = gallery || []
      if (this.prodGallery.length > 0) {
        this.showDialogPreView = true
      }
    },
    close () {
      this.internalDialog = false
    },
    async buildDataChangTime () {
      try {
        this.formChangTime.remark = ''
        this.formChangTime.empSelect = ''
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
        this.dueDateSelect = ''
        this.dueTimeSelect = ''
        await this.getDataBranch()
        await this.getGroupFlow()
        await this.getFlowById(this.dataChangTime.flowId)
        await this.selectGroupFlow()
        this.formChangTime.flowId = this.dataChangTime.flowId
        this.timeSlot = this.DataFlowAll.filter((item) => item.flowId === this.formChangTime.flowId)[0].timeSlot
        this.checkBranch()
        this.checkTitleEmp()
        this.selectedEmpList = this.dataChangTime.bookingEmpArray
        this.formChangTime.dueDate = this.dataChangTime.dueDateDay
        this.formChangTime.dueTime = this.dataChangTime.timeText
        let currentMoment = moment(this.date, 'YYYY-MM').format('YYYY-MM')
        let dueDateMoment = moment(this.dataChangTime.dueDateDay, 'YYYY-MM-DD').format('YYYY-MM')
        if (dueDateMoment > currentMoment) {
          this.previous = true
          this.date = moment(dueDateMoment, 'YYYY-MM').format('YYYY-MM')
        }
        // await this.getCalendarQueueVela()
        await this.checkDefaultTime()
      } catch (error) {
        console.log('buildDataChangTime : ', error)
        this.internalDialog = false
      }
    },
    async checkDefaultTime () {
      let filterDate = this.queueForMonth.filter((item) => item.date === this.formChangTime.dueDate)
      if (filterDate.length > 0) {
        this.dueTimeSelect = this.dataChangTime.timeText
      }
    },
    async getDetailsVelaStart (dueDate, dueTime) {
      // this.queueForDateSelect = []
      // this.dueDateSelect = ''

      // let currentMoment = moment(this.date, 'YYYY-MM').format('YYYY-MM')
      // let dueDateMoment = moment(this.dataChangTime.dueDateDay, 'YYYY-MM-DD').format('YYYY-MM')
      // console.log('1dueDateMoment', dueDateMoment, 'currentMoment', currentMoment, (dueDateMoment < currentMoment))
      // if (dueDateMoment < currentMoment) {
      //   console.log('2dueDateMoment', dueDateMoment, 'currentMoment', currentMoment)
      //   this.dueTimeSelect = ''
      // }
      let key = 0
      this.queueForMonth.forEach((i, u) => {
        if (i.date === dueDate) {
          key = i
          this.dueDateSelect = i.date
          this.dueTimeSelect = dueTime
          i.active = true
        } else {
          i.active = false
        }
      })
      let filterSelect = this.queueForMonth.filter((item) => item.active === true)
      if (filterSelect.length > 0) {
        this.queueForDateSelect = filterSelect[0].available_time
      } else {
        this.queueForDateSelect = []
      }
      this.model = key
    },
    async getEmpAdmin (item) {
      this.employeeAdminName = []
      await axios
        .get(
          this.$DNS_IP +
            '/empSelect/getUse?privacyPage=booking&shopId=' +
            item.shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              if (d.masBranchID === item.masBranchID) {
                let s = {}
                s.text = d.empFirst_NameTH
                s.value = d.empId
                this.employeeAdminName.push(s)
              } else if (d.masBranchID === null || d.masBranchID === '') {
                let s = {}
                s.text = d.empFirst_NameTH
                s.value = d.empId
                this.employeeAdminName.push(s)
              }
            }
          }
        })
    },
    async getCalendarQueueVela () {
      const payload = {
        'dateMonth': this.date,
        'timeSlot': this.timeSlot,
        'empId': this.selectedEmpList,
        'due_time_old': this.formChangTime.dueTime,
        'due_date_old': this.formChangTime.dueDate
      }
      this.overlayBulidQueue = true
      try {
        const result = await axios.post(this.$DNS_IP + '/employee_vela/get_calendar_queue_chang_time', payload)
        if (result.data.status) {
          this.queueForMonth = result.data.message
          await this.defaultDetailsVela()
        } else {
          this.queueForMonth = []
        }
      } catch (error) {
        console.log('error get calendar', error)
        this.queueForMonth = []
      } finally {
        this.overlayBulidQueue = false
      }
    },
    async defaultDetailsVela () {
      for (let index = 0; index < this.queueForMonth.length; index++) {
        const element = this.queueForMonth[index]
        if (element.active) {
          if (!this.statusStart) {
            this.statusStart = true
            await this.getDetailsVelaStart(this.formChangTime.dueDate, this.formChangTime.dueTime)
          } else {
            this.getDetailsVela(element, index)
          }
        }
      }
    },
    async getDetailsVela (item, key) {
      this.queueForDateSelect = []
      this.dueDateSelect = ''
      this.queueForMonth.forEach((i, u) => {
        if (u !== key) {
          i.active = false
        } else {
          this.dueDateSelect = i.date
        }
      })
      let filterSelect = this.queueForMonth.filter((item) => item.active === true)
      if (filterSelect.length > 0) {
        this.queueForDateSelect = filterSelect[0].available_time
      } else {
        this.queueForDateSelect = []
      }
      this.model = key
    },
    async getFlowById (flowId) {
      try {
        let response = await axios.get(this.$DNS_IP + '/flow/get?flowId=' + flowId)
        if (response.data.length > 0) {
          this.formChangTime.group_Flow_Id = response.data[0].group_Flow_Id
        }
      } catch (error) {
        console.log('error-getGroupFlow', error)
      }
    },
    async getDataBranch () {
      this.branch = []
      this.branchData = []
      await axios.get(this.$DNS_IP + '/master_branch/get?shopId=' + this.$session.getAll().data.shopId).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            let s = {}
            s.text = d.masBranchName
            s.textEn = d.masBranchNameEn
            s.value = d.masBranchID
            this.branch.push(s)
            this.branchData.push(d)
          }
          if (this.branch.length === 1) {
            this.formChangTime.masBranchID = this.branch[0].value
            this.CaseOneBranch()
          }
        }
      })
    },
    async CaseOneBranch () {
      await this.selectBranch()
      // await this.flowOne()
    },
    async selectBranch () {
      this.formChangTime.group_Flow_Id = ''
      await this.getGroupFlow()
    },
    async selectGroupFlow () {
      this.formChangTime.flowId = ''
      await this.getDataFlow()
    },
    async getEmp () {
      this.dataEmp = []
      this.dataEmpAll = []
      await axios.get(this.$DNS_IP + '/empSelect/get?privacyPage=bookingform&masBranchID=' + this.formChangTime.masBranchID).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            if (d.flowId !== null && d.flowId !== '') {
              let checkFlowId = JSON.parse(d.flowId)
              if (checkFlowId.filter((a) => parseInt(a) === this.formChangTime.flowId).length > 0) {
                if (d.setTime !== null && d.setTime !== '[]' && d.setTime !== '') {
                  let s = {}
                  s.text = d.empFull_NameTH
                  s.textEng = d.empFull_NameTH
                  s.value = d.empId
                  s.creditpackage = d.credit_package
                  this.dataEmp.push(s)
                  d.picture = JSON.parse(d.pictureList) || []
                  this.dataEmpAll.push(d)
                }
              }
            }
          }
          if (this.dataEmp.length === 0) {
            this.$swal(
              this.languageSelect === 0 ? 'ไม่มี' + this.empTitleTh + 'สำหรับประเภทบริการนี้' : 'There is no ' + this.empTitleEng + ' for this type of service.',
              this.languageSelect === 0 ? 'กรุณาเลือกประเภทบริการอื่นๆ' : 'Please select another type of service.',
              'info'
            )
          }
        } else {
          this.dataEmp = []
          this.dataEmpAll = []
        }
      })
    },
    async getDataFlow () {
      this.DataFlowAll = []
      this.DataFlow = []
      let dataFlow = []
      let dataFlowName = []
      await axios.get(this.$DNS_IP + '/flow/get?shopId=' + this.$session.getAll().data.shopId).then(response => {
        let rs = response.data
        if (rs.length > 0) {
          for (var i = 0; i < rs.length; i++) {
            let d = rs[i]
            let checkBranchByFlow = d.masBranchID || 'All'
            if ((checkBranchByFlow === this.formChangTime.masBranchID.toString()) || checkBranchByFlow === 'All') {
              if (d.group_Flow_Id === this.formChangTime.group_Flow_Id) {
                d.text = d.flowName
                d.textEn = d.flowNameEn
                d.value = d.flowId
                dataFlowName.push(d)
                dataFlow.push(d)
              }
            }
          }
          this.DataFlowAll = dataFlowName
          this.DataFlow = dataFlow
        } else {
          this.DataFlow = []
          this.DataFlowAll = []
        }
      })
    },
    async getGroupFlow () {
      try {
        this.groupFlow = []
        let response = await axios.get(this.$DNS_IP + '/Group_Flow/get?shopId=' + this.$session.getAll().data.shopId)
        for (let index = 0; index < response.data.length; index++) {
          const element = response.data[index]
          if (parseInt(element.masBranchID) === parseInt(this.formChangTime.masBranchID)) {
            let s = {}
            s.text = element.groupName
            s.textEng = element.groupNameEn
            s.value = element.group_Flow_Id
            this.groupFlow.push(s)
          }
        }
      } catch (error) {
        console.log('error-getGroupFlow', error)
      }
    },
    async checkBranch (defaultEmp = '') {
      let dataFlowFilter = this.DataFlowAll.filter((item) => item.flowId === this.formChangTime.flowId)
      try {
        if (this.formChangTime.masBranchID !== '') {
          this.timeSlot = dataFlowFilter[0].timeSlot
          this.formChangTime.empId = defaultEmp
          await this.getEmp()
        }
      } catch (err) {
        if (this.formChangTime.masBranchID !== '') {
          this.timeSlot = dataFlowFilter[0].timeSlot
          this.formChangTime.empId = defaultEmp
          await this.getEmp()
        }
      }
    },
    checkTitleEmp () {
      let checkDataEmpTitle = this.DataFlowAll.filter(el => { return el.flowId === this.formChangTime.flowId })
      if (checkDataEmpTitle.length > 0) {
        this.empTitleTh = checkDataEmpTitle[0].empTitleTh || 'พนักงานช่าง'
        this.empTitleEng = checkDataEmpTitle[0].empTitleEng || 'Employee'
      } else {
        this.empTitleTh = 'พนักงานช่าง'
        this.empTitleEng = 'Employee'
      }
    },
    async setMonthCarousel (item) {
      if (item === 'next') {
        this.date = moment(this.date).add(1, 'months').format('YYYY-MM')
      } else if (item === 'next_bookingNowCheckCount_month') {
        this.date = moment(this.date).add(1, 'months').format('YYYY-MM')
      } else if (item === 'previous') {
        this.date = moment(this.date).add(-1, 'months').format('YYYY-MM')
      } else {

      }
      if (moment(this.date, 'YYYY-MM').format('YYYY-MM') > moment(this.currentMonth, 'YYYY-MM').format('YYYY-MM')) {
        if (this.next_bookingNowCheckCount_month === 'False') {
          this.previous = true
        }
      } else {
        this.previous = false
      }
      await this.getCalendarQueueVela()
    },
    async selectTime (time) {
      // this.formChangTime.dueTime = time
      this.dueTimeSelect = time
      // await this.openDialogCustomField()
    },
    async checkLimitBooking () {
      try {
        const payload = {
          'dateDay': this.dueDateSelect,
          'dateTime': this.dueTimeSelect,
          'timeSlot': this.timeSlot,
          'empId': this.selectedEmpList,
          'due_time_old': this.formChangTime.dueTime,
          'due_date_old': this.formChangTime.dueDate
        }
        const response = await axios.post(this.$DNS_IP + '/employee_vela/check_limit_by_date_chang_time', payload)
        if (response.data.status) {
          if (response.data.limit_full) {
            this.$swal(
              this.languageSelect === 0 ? 'มีลูกค้าท่านอื่นนัดหมายเวลานี้แล้ว' : 'There are other customers making appointments at this time.',
              this.languageSelect === 0 ? 'กรุณาเลือกวันที่ / เวลา ใหม่อีกครั้ง' : 'Please select a new date/time again.',
              'info'
            )
            return false
          } else {
            return true
          }
        } else {
          this.$swal(
            this.languageSelect === 0 ? 'พบความผิดพลาดระหว่างดำเนินการ' : 'An error was encountered during the operation.',
            this.languageSelect === 0 ? 'กรุณาลองใหม่อีกครั้ง' : 'Please press the button to fetch new data.',
            'info'
          )
          return false
        }
      } catch (error) {
        console.log('error', error)
        return false
      }
    },
    async ChangTimeCheck () {
      await this.$nextTick() // รอให้ overlay render ก่อน
      const isValid = this.$refs.form.validate()
      if (isValid) {
        if (this.dueTimeSelect !== '' && this.dueDateSelect !== '') {
          let statusCheckLimit = await this.checkLimitBooking()
          await this.submitChangTime(statusCheckLimit)
        } else {
          this.$swal(
            'ผิดพลาด',
            'กรุณาเลือกวันที่และเวลาที่ต้องการเปลี่ยน',
            'info'
          )
          this.overlayComponent = false
        }
      }
    },
    async submitChangTime (status) {
      if (status) {
        try {
          const dataChangTime = {
            'remark': this.formChangTime.remark.replace(/%/g, '%%'),
            'bookingEmpArray': JSON.stringify(this.selectedEmpList),
            'bookNo': this.dataChangTime.bookNo,
            'dueDate': this.dueDateSelect + ' ' + this.dueTimeSelect,
            'timeText': this.dueTimeSelect,
            'shopId': this.dataChangTime.shopId,
            'countChangeTime': parseInt(this.dataChangTime.countChangeTime) + 1,
            'empSelect': this.formChangTime.empSelect,
            'LAST_USER': this.$session.getAll().data.userName,
            'due_time': this.dueTimeSelect,
            'due_date': this.dueDateSelect,
            'due_time_old': this.formChangTime.dueTime,
            'due_date_old': this.formChangTime.dueDate,
            'bookingEmpArray_old': this.dataChangTime.bookingEmpArray,
            'flowId': this.formChangTime.flowId,
            'masBranchID': this.formChangTime.masBranchID,
            'flowId_old': this.dataChangTime.flowId,
            'masBranchID_old': this.dataChangTime.masBranchID,
            'timeSlot': this.timeSlot
          }
          console.log('dataChangTime', dataChangTime)
          this.$swal({
            title: this.languageSelect === 0 ? 'ยืนยันรายการนัดหมาย' : 'Please confirm your booking',
            type: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#b3b1ab',
            confirmButtonText: this.languageSelect === 0 ? 'ใช่' : 'Yes',
            cancelButtonText: this.languageSelect === 0 ? 'ไม่' : 'No'
          }).then(async result => {
            this.overlayComponent = true
            const responseChantTime = await axios.post(this.$DNS_IP + '/employee_vela/chang_time_booking', dataChangTime)
            if (responseChantTime.status) {
              if (this.dataChangTime.statusBt === 'confirm') {
                this.pushMsgConfirmChangeTime(this.dataChangTime.bookNo)
              }
              await this.resetData()
              this.$swal(
                'เรียบร้อย',
                'เปลี่ยนเวลานัดหมาย เรียบร้อย',
                'success'
              )
              this.overlayComponent = false
            } else if (!responseChantTime.status && responseChantTime.message === 'LimitBooking_Full') {
              this.$swal(
                this.languageSelect === 0 ? 'มีลูกค้าท่านอื่นนัดหมายเวลานี้แล้ว' : 'There are other customers making appointments at this time.',
                this.languageSelect === 0 ? 'กรุณาเลือกวันที่ / เวลา ใหม่อีกครั้ง' : 'Please select a new date/time again.',
                'info'
              )
            } else {
              this.$swal(
                'ผิดพลาด',
                'ไม่สามารถแก้ไขวันที่และเวลานัดหมายได้กรุณาลองใหม่อีกครั้ง',
                'info'
              )
            }
          })
        } catch (error) {
          this.$swal(
            'ผิดพลาด',
            'ไม่สามารถแก้ไขวันที่และเวลานัดหมายได้กรุณาลองใหม่อีกครั้ง',
            'info'
          )
        } finally {
          this.overlayComponent = false
        }
      } else {
        this.$swal(
          'ผิดพลาด',
          'ไม่สามารถแก้ไขวันที่และเวลานัดหมายได้กรุณาลองใหม่อีกครั้ง',
          'info'
        )
        this.overlayComponent = false
      }
    },
    pushMsgConfirmChangeTime (bookNo) {
      try {
        const payload = {
          dueDateOld: this.dataChangTime.dueDate,
          sendRemarkChang: this.formChangTime.remark
        }
        const responsPushMessage = axios.post(this.$DNS_IP + '/Booking/pushMsgConfirmChamgeTime/' + bookNo, payload)
        console.log('responsPushMessage', responsPushMessage)
      } catch (error) {
        console.log('error push message', error)
      }
    },
    async resetData () {
      await this.$emit('resetData')
      this.internalDialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VelaStudio/DialogChangTime.vue